import { Box, Card, CardActionArea, CardContent, Grid, Stack, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PageArea from '../../components/shared/PageArea';
import PageTitle from '../../components/shared/PageTitle';
import { UserContext } from '../../components/shared/useUser';
import { integrationCatalog } from './catalog';

const Integrations = () => {
  const { t } = useTranslation('drawer');
  const { hasPermissionTo, selectedSystem, systems } = useContext(UserContext);
  const available = integrationCatalog.filter(item =>
    hasPermissionTo(item.permissions)
      && (systems.some(system => system.id === 0)
        || (selectedSystem != null && item.systemIds.includes(selectedSystem.id))));

  return <PageArea>
    <PageTitle subTitle={t('integrationsDescription')}>{t('integrations')}</PageTitle>
    {available.length === 0
      ? <Typography color="text.secondary">{t('integrationsEmpty')}</Typography>
      : <Grid container
        spacing={3}>
        {available.map(item => <Grid item
          xs={12}
          md={6}
          lg={4}
          key={item.id}>
          <Card variant="outlined"
            sx={{ height: '100%' }}>
            <CardActionArea component={Link}
              to={item.path}
              sx={{ height: '100%' }}>
              <CardContent>
                <Stack direction="row"
                  alignItems="center"
                  spacing={2}>
                  <Box sx={{ color: 'primary.main', display: 'flex' }}>{item.icon}</Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="textLG">{t(item.titleKey)}</Typography>
                    <Typography variant="textSM"
                      color="text.secondary"
                      display="block">
                      {t(item.descriptionKey)}
                    </Typography>
                  </Box>
                  <ChevronRight color="action" />
                </Stack>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>)}
      </Grid>}
  </PageArea>;
};

export default Integrations;
